import { TextField } from '@mui/material';
import { EditApiKeyForm } from 'components/Drawer/types';
import dayjs from 'dayjs';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

export interface Props {
  register: UseFormRegister<EditApiKeyForm>;
  nameInputValue: string | undefined;
  handleNameInputOnChange: (value: string) => void;
  nameInputValidation: string | undefined;
  referenceInputValue: string | undefined;
  creationDateInputValue: string | undefined;
  showValidation: boolean;
}

const EditApiKey: React.FC<React.PropsWithChildren<Props>> = ({
  register,
  nameInputValue,
  handleNameInputOnChange,
  nameInputValidation,
  showValidation,
  referenceInputValue,
  creationDateInputValue
}) => {
  const { translation } = useTranslation();

  return (
    <ComponentWrapper flexDirection="column" gap="1.5rem" margin="0.5rem 0 0 0">
      <TextField
        {...register('name')}
        onChange={(event) => handleNameInputOnChange(event.target.value)}
        variant="outlined"
        InputLabelProps={{ shrink: !!nameInputValue || undefined }}
        size="medium"
        label={translation.name}
        value={nameInputValue}
        id="drawer-input-name"
        error={showValidation && nameInputValidation !== undefined}
        helperText={showValidation ? nameInputValidation : undefined}
      />
      <TextField
        {...register('reference')}
        variant="outlined"
        size="medium"
        label={translation.api_key_reference}
        value={referenceInputValue}
        id="drawer-input-api-key-reference"
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{
          style: {
            fontFamily: 'Courier New',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.15px'
          }
        }}
        disabled
      />
      <TextField
        {...register('creationDate')}
        variant="outlined"
        size="medium"
        label={translation.creation_date}
        value={creationDateInputValue ? dayjs(creationDateInputValue).format('YYYY-MM-DD HH:mm') : ''}
        id="drawer-input-api-key-creation-date"
        InputLabelProps={{ shrink: true }}
        disabled
      />
    </ComponentWrapper>
  );
};

export default EditApiKey;
